module.exports = __webpack_public_path__ + "img/hall-page-fade.b9817226.png";